import { render, staticRenderFns } from "./YearlyEnergyProfile.vue?vue&type=template&id=0a56bfa2&scoped=true&"
import script from "./YearlyEnergyProfile.vue?vue&type=script&lang=js&"
export * from "./YearlyEnergyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56bfa2",
  null
  
)

export default component.exports